module.exports = __webpack_public_path__ + "img/practice-1.9e1a2c03.jpg";